import { render, staticRenderFns } from "./Kataloganfordern.vue?vue&type=template&id=29346b5f&scoped=true&"
import script from "./Kataloganfordern.vue?vue&type=script&lang=js&"
export * from "./Kataloganfordern.vue?vue&type=script&lang=js&"
import style0 from "./Kataloganfordern.vue?vue&type=style&index=0&id=29346b5f&lang=scss&scoped=true&"
import style1 from "./Kataloganfordern.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29346b5f",
  null
  
)

export default component.exports